import { dateTimeFormat } from "@/common/constant/DateTimeFormat.js";
import moment from "moment-timezone";
import store from "@/store";

const formatMinutes = (minute) => {
  // Check if minute is null
  if (!minute) {
    return null;
  }
  return `${minute.toString()}min`;
};

const formatMinutesUpperCase = (minute) => {
  // Check if minute is null
  if (!minute) {
    return null;
  }
  return `${minute.toString()} Min`;
};

const formatMinutesLowerCase = (minute) => `${minute.toString()} Mins`;

const calculateDurationInMinutes = (startTime, endTime) => {
  let st = new Date(startTime);
  let et = new Date(endTime);

  return `${((et - st) / 60000).toString()} Min`;
};

const convertDateFormat = (date) => {
  // Check if date is null
  if (!date) {
    return null;
  }

  return moment(new Date(date)).format(dateTimeFormat.GENERAL_DATE_FORMAT);
};

const convertToTime = (date) => {
  // Check if date is null
  if (!date) {
    return null;
  }

  return moment(new Date(date)).format(dateTimeFormat.TIME_FORMAT);
};

const getTodaysDate = () => {
  // Get todays date in YYYY-MM-DD
  return moment(new Date()).format(dateTimeFormat.API_DATE_FORMAT);
};

const convertDateToDatabaseFormat = (originalDate) => {
  if (originalDate === "") {
    return null;
  }
  // Convert date to YYYY-MM-DD
  return moment(new Date(originalDate)).format(dateTimeFormat.API_DATE_FORMAT);
};

const convertDateTimeToTimezone = ({
  dateTime,
  format = dateTimeFormat.API_DATE_TIME_FORMAT,
  outputFormat = dateTimeFormat.API_DATE_TIME_FORMAT,
}) => {
  return moment
    .utc(dateTime, format)
    .tz(store.getters.selectedBranch.timezone)
    .format(outputFormat);
};

const convertDateTimeToUTC = ({
  dateTime,
  format = dateTimeFormat.API_DATE_TIME_FORMAT,
  timezone = moment.tz.guess(true), // moment.js determine timezone based on browser
  outputFormat = dateTimeFormat.API_DATE_TIME_FORMAT,
}) => {
  return moment.tz(dateTime, format, timezone).utc().format(outputFormat);
};

const addMinutesToTime = (time, minutes) => {
  return moment(time, dateTimeFormat.TIME_FORMAT)
    .add(minutes, "minutes")
    .format(dateTimeFormat.TIME_FORMAT);
};

export {
  formatMinutes,
  formatMinutesUpperCase,
  formatMinutesLowerCase,
  calculateDurationInMinutes,
  convertDateFormat,
  convertToTime,
  getTodaysDate,
  convertDateToDatabaseFormat,
  convertDateTimeToTimezone,
  convertDateTimeToUTC,
  addMinutesToTime,
};
